import React from 'react'
import CommentCard from './CommentCard';
import "./LikesComments.css";

export default function LikesAndComments() {
  return (
    <div className='likes-comments-cont'>
        <div className='likes-share'>
            <div>
                <p>Likes</p>
                <p>999</p>
            </div>
            <div>
                <p>Share</p>
            </div>
        </div>

        <div className="head-comments">
            Comments
        </div>

        <div className='comment-section'>
            <CommentCard />
            <CommentCard />
            <CommentCard />
            <CommentCard />
            <CommentCard />
        </div>

        <div className='comment-input-box'>
            <input type="text" placeholder='Write a comment' />
            <button>Post</button>
        </div>
    </div>
  )
}
